export default "__VITE_ASSET__5e5ae1ab__"